import React, { useState, useEffect } from 'react';
import { Eye, Edit, Trash2, Search, Filter, RefreshCw, ChevronLeft, ChevronRight } from 'lucide-react';
import './PublishedProducts.css';
import MasterLayout from '../../masterLayout/MasterLayout';
import { BASE_URL, IMG_URL } from '../../helper/api_helper';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';

const PublishedProducts = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, productId: null, productName: '' });

  console.log("Delete MOdal", deleteModal)
  const [viewModal, setViewModal] = useState({ isOpen: false, product: null });

  const itemsPerPage = 9;

  const fetchProducts = async (categoryId = "") => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}/products/get-all-products`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ categoryId }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }

      const result = await response.json();

      if (result.status) {
        setProducts(result.data || []);
        setTotalPages(result.totalPages || 1);
      } else {
        toast.error(result.message || "Failed to fetch products");
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to load products. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchProducts();
  }, [currentPage]);

  const handleDelete = async (productId) => {
    try {
      const response = await fetch(`${BASE_URL}/products/delete-product/${productId}`, {
        method: 'DELETE',
      });

      const result = await response.json();

      if (result.status) {
        toast.success(result.message || 'Product deleted successfully');
        setDeleteModal({ isOpen: false, productId: null, productName: '' });
        fetchProducts();
      } else {
        toast.error(result.message || 'Failed to delete product');
      }
    } catch (error) {
      console.error('Error deleting product:', error);
      toast.error('Failed to delete product. Please try again.');
    }
  };



  const handleViewDetails = (product) => {
    setViewModal({ isOpen: true, product });
  };

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.productName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.medicineName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.genericName?.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesSearch;
  });

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const ProductCard = ({ product }) => {
    const firstImage = product.productImages && product.productImages.length > 0
      ? `${IMG_URL}/${product.productImages[0]}`
      : '/placeholder-product.jpg';

    return (
      <div className="product-card-item">
        <div className="product-image-container">
          <img src={firstImage} alt={product.productName} className="product-image" />
          <div className="product-badge">{product.status || 'Published'}</div>
        </div>

        <div className="product-card-content">
          <h3 className="product-card-title">{truncateText(product.productName, 40)}</h3>
          <p className="product-card-subtitle">{product.medicineName}</p>
          <p className="product-card-generic">{product.genericName}</p>

          <div className="product-card-info">
            <div className="info-item">
              <span className="info-label">Dosage:</span>
              <span className="info-value">{truncateText(product.dosageForm, 25)}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Manufacturer:</span>
              <span className="info-value">{truncateText(product.manufacturer, 25)}</span>
            </div>
          </div>

          <p className="product-card-description">
            {truncateText(product.productDescription, 100)}
          </p>

          <div className="product-card-actions">
            <button
              className="btn-action btn-view"
              onClick={() => handleViewDetails(product)}
              title="View Details"
            >
              <Eye className="icon-sm" />
              View
            </button>
            {/* <button
              className="btn-action btn-edit"
              onClick={() => navigate(`/create-product?id=${product.id}`)}
              title="Edit Product"
            >
              <Edit className="icon-sm" />
              Edit
            </button> */}
            <button
              className="btn-action btn-delete"
              onClick={() => setDeleteModal({
                isOpen: true,
                productId: product.id,
                productName: product.productName
              })}
              title="Delete Product"
            >
              <Trash2 className="icon-sm" />
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  };
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <MasterLayout>
      <Breadcrumb title="Published Products" />
      <div className="published-products-container">
        <div className="published-products-wrapper">

          <div className="" style={{display:"flex", justifyContent:"end", marginBottom:"30px"}}>
            <input
              type="text"
              placeholder="Search products..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>


          {loading ? (
            <div className="loading-container">
              <div className="spinner-large"></div>
              <p>Loading products...</p>
            </div>
          ) : filteredProducts.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">📦</div>
              <h3>No products found</h3>
              <p>Try adjusting your search or add a new product</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/create-product')}
              >
                Add Your First Product
              </button>
            </div>
          ) : (
            <>
              <div className="products-grid">
                {filteredProducts.map((product) => (
                  <ProductCard key={product._id} product={product} />
                ))}
              </div>

              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  >
                    <ChevronLeft className="icon-sm" />
                    Previous
                  </button>

                  <div className="pagination-info">
                    Page {currentPage} of {totalPages}
                  </div>

                  <button
                    className="pagination-btn"
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  >
                    Next
                    <ChevronRight className="icon-sm" />
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {deleteModal.isOpen && (
          <div className="modal-overlay" onClick={() => setDeleteModal({ isOpen: false, productId: null, productName: '' })}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Delete Product</h3>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete <strong>{deleteModal.productName}</strong>?</p>
                <p className="modal-warning">This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setDeleteModal({ isOpen: false, productId: null, productName: '' })}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleDelete(deleteModal.productId)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {viewModal.isOpen && viewModal.product && (
          <div className="modal-overlay" onClick={() => setViewModal({ isOpen: false, product: null })}>
            <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Product Details</h3>
                <button
                  className="modal-close"
                  onClick={() => setViewModal({ isOpen: false, product: null })}
                >
                  ×
                </button>
              </div>
              <div className="modal-body modal-body-scroll">
                {viewModal.product.productImages && viewModal.product.productImages.length > 0 && (
                  <div className="modal-images">
                    {viewModal.product.productImages.map((img, index) => (
                      <img
                        key={index}
                        src={`${IMG_URL}/${img}`}
                        alt={`${viewModal.product.productName} ${index + 1}`}
                        className="modal-image"
                      />
                    ))}
                  </div>
                )}

                <div className="modal-section">
                  <h4 className="modal-section-title">Basic Information</h4>
                  <div className="modal-details-grid">
                    <div className="modal-detail-item">
                      <span className="detail-label">Product Name:</span>
                      <span className="detail-value">{viewModal.product.productName}</span>
                    </div>
                    <div className="modal-detail-item">
                      <span className="detail-label">Medicine Name:</span>
                      <span className="detail-value">{viewModal.product.medicineName}</span>
                    </div>
                    <div className="modal-detail-item">
                      <span className="detail-label">Generic Name:</span>
                      <span className="detail-value">{viewModal.product.genericName}</span>
                    </div>
                    <div className="modal-detail-item">
                      <span className="detail-label">Dosage Form:</span>
                      <span className="detail-value">{viewModal.product.dosageForm}</span>
                    </div>
                    <div className="modal-detail-item">
                      <span className="detail-label">Manufacturer:</span>
                      <span className="detail-value">{viewModal.product.manufacturer}</span>
                    </div>
                  </div>

                  {viewModal.product.productDescription && (
                    <div className="modal-detail-item-full">
                      <span className="detail-label">Description:</span>
                      <p className="detail-value">{viewModal.product.productDescription}</p>
                    </div>
                  )}
                </div>

                {(viewModal.product.medicalTitle || viewModal.product.primaryUse) && (
                  <div className="modal-section">
                    <h4 className="modal-section-title">Medical Uses</h4>
                    {viewModal.product.medicalTitle && (
                      <div className="modal-detail-item-full">
                        <span className="detail-label">Title:</span>
                        <p className="detail-value">{viewModal.product.medicalTitle}</p>
                      </div>
                    )}
                    {viewModal.product.medicalDescription && (
                      <div className="modal-detail-item-full">
                        <span className="detail-label">Description:</span>
                        {/* <p className="detail-value">{viewModal.product.medicalDescription}</p> */}

                        <div className="detail-value" dangerouslySetInnerHTML={{ __html: viewModal?.product?.medicalDescription }} />

                      </div>
                    )}
                    {viewModal.product.primaryUse && (
                      <div className="modal-detail-item-full">
                        <span className="detail-label">Primary Use:</span>
                        <p className="detail-value">{viewModal.product.primaryUse}</p>
                      </div>
                    )}
                    {viewModal.product.clinicalOverview && (
                      <div className="modal-detail-item-full">
                        <span className="detail-label">Clinical Overview:</span>
                        <p className="detail-value">{viewModal.product.clinicalOverview}</p>
                      </div>
                    )}
                  </div>
                )}

                {viewModal.product.warnings && (
                  <div className="modal-section">
                    <h4 className="modal-section-title">Warnings & Precautions</h4>
                    {/* <p className="detail-value">{viewModal.product.warnings}</p> */}
                    <div className="detail-value" dangerouslySetInnerHTML={{ __html: viewModal.product.warnings }} />

                  </div>
                )}

                {viewModal.product.documentation && (
                  <div className="modal-section">
                    <h4 className="modal-section-title">Documentation & Availability</h4>
                    {/* <p className="detail-value">{viewModal.product.documentation}</p> */}
                    <div className="detail-value" dangerouslySetInnerHTML={{ __html: viewModal.product.documentation }} />

                  </div>
                )}

                {viewModal.product.sourcing && (
                  <div className="modal-section">
                    <h4 className="modal-section-title">Sourcing & Delivery</h4>
                    {/* <p className="detail-value">{viewModal.product.sourcing}</p> */}
                    <div className="detail-value" dangerouslySetInnerHTML={{ __html: viewModal.product.sourcing }} />

                  </div>
                )}

                {viewModal.product.faqs && viewModal.product.faqs.length > 0 && (
                  <div className="modal-section">
                    <h4 className="modal-section-title">FAQs</h4>
                    {viewModal.product.faqs.map((faq, index) => (
                      <div key={index} className="faq-item-modal">
                        <h5 className="faq-title">{faq.title}</h5>
                        <p className="faq-description">{faq.description}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setViewModal({ isOpen: false, product: null })}
                >
                  Close
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    handleEdit(viewModal.product._id);
                    setViewModal({ isOpen: false, product: null });
                  }}
                >
                  <Edit className="icon-sm" />
                  Edit Product
                </button>
              </div> */}
            </div>
          </div>
        )}
      </div>
    </MasterLayout>
  );
};

export default PublishedProducts;